import styled from 'styled-components';
import { media, Button } from '@simplywallst/ui-core';

export const MultipleVsPeersWrapper = styled('div')`
  position: relative;
`;

export const ToggleWrapper = styled('div')`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  ${media.smUp`
    position: absolute;
    left: 0;
    bottom: 0;
    margin-bottom: 0;
  `}
`;
export const ToggleLabel = styled('span')`
  opacity: 50%;
  font-size: 1.2rem;
`;

export const DropdownWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const PillButton = styled(Button)`
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  svg > * {
    fill: ${({ theme }) => theme.color.brand01};
  }
`;
